import { makeAutoObservable } from 'mobx'
import { nanoid } from 'nanoid'
import modalStore from 'shared/ui/Modal/store/modalStore'
import { ConversationsApi } from 'entities/Conversation'
import { type ExportFormatType } from 'widgets/ExportConversationModal'
import { ExportStore } from 'widgets/Export'
import { ExportConversationsModalsContent } from 'widgets/ExportConversationModal/ui/ExportConversationsModalsContent'
import { ExportConversationsModalsActions } from 'widgets/ExportConversationModal/ui/ExportConversationsModalsActions'

export class ExportConversationModalStore {
  private _exportConversationId: number | null = null
  private _format: ExportFormatType | null = null
  private _includeNote = false
  private _idModal = ''
  private readonly _exportStore = new ExportStore()

  constructor() {
    makeAutoObservable(this)
  }

  get includeNote() {
    return this._includeNote
  }

  get format() {
    return this._format
  }

  get disabled() {
    return !this._format
  }

  onExport = async () => {
    if (!this._exportConversationId || !this._format) return

    modalStore.closeModal(this._idModal)

    await this._exportStore.getExport({
      promise: ConversationsApi.updateByIdExport({
        id: this._exportConversationId,
        format: this._format.toLowerCase(),
        includeNotes: this._includeNote,
      }),
      preparingTitle: 'Export → Conversation',
      successTitle: 'Export → Conversation',
    })
  }

  onOpenExport = (id: typeof this._exportConversationId) => {
    this._format = null
    this._includeNote = false
    this._exportConversationId = id
    this._idModal = nanoid()

    modalStore.addModal({
      id: this._idModal,
      title: 'Export conversation',
      ModalActions: ExportConversationsModalsActions,
      ModalContent: ExportConversationsModalsContent,
      ModalContentProps: { store: this },
    })
  }

  setFormat = (format: ExportFormatType) => {
    this._format = format
  }

  toggleIncludeNote = () => {
    this._includeNote = !this._includeNote
  }
}
